var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutAuto',[_c('div',{staticClass:"header"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.formInfo.approvalName))])]),_c('Sponsor',{ref:"sponsor",attrs:{"approvalInfo":_vm.formInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }